export default __webpack_public_path__ + "static/media/image6.1b62d059.jpg";